import React, { memo } from 'react';

import Button from '../helpers/Button';
import FormGroup from '../helpers/FormGroup';
import FormErrors from '../helpers/FormErrors';
import Input from '../helpers/Input';
import Select from '../helpers/Select';
import { Card } from '../helpers/Card';

import style from './style.module.css';

const EditorComponent = ({
  mode,
  category,
  errors,
  showParent,
  parentId,
  isLinkable,
  parents,
  isSuper,
  loading,
  onChange,
  onSave,
  onCancel,
}) => {
  if (mode === 'view') return null;

  const actions = (
    <>
      <Button className="btn-primary" disabled={loading || !isSuper} onClick={onSave}>
        Save
      </Button>
      <Button disabled={loading || !isSuper} onClick={onCancel}>
        Cancel
      </Button>
    </>
  );

  return (
    <Card actions={actions} title={mode === 'edit' ? 'Edit Category' : 'Add Category'}>
      <div className="row">
        <FormGroup className="col-md-4 mb0">
          <Input label="Category Name" name="category" onChange={onChange} value={category} showLabel />
        </FormGroup>
        {showParent && (
          <FormGroup className="col-md-4 mb0">
            <Select
              defaultText=" "
              defaultValue=""
              label="Parent Category"
              name="parentId"
              nameKey="category"
              onChange={onChange}
              options={parents}
              value={parentId}
              valueKey="id"
              showLabel
            />
          </FormGroup>
        )}
        <FormGroup className="col-md-2 mb0">
          <div className={style.linkable}>
            <div className="checkbox-wrap">
              <input checked={isLinkable} id="isLinkable" name="isLinkable" onChange={onChange} type="checkbox" />
              <label htmlFor="isLinkable">Is Linkable</label>
            </div>
          </div>
        </FormGroup>
      </div>
      <FormErrors errors={errors} />
    </Card>
  );
};

export const Editor = memo(EditorComponent);
